import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supportTicketServices } from '../services/support-ticket.service';
import toast from 'react-hot-toast';

export const useDeleteTicket = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (ticketId) => supportTicketServices.deleteTicket(ticketId),
    onSuccess: () => {
      queryClient.invalidateQueries(['support-tickets']);
      toast.success('Ticket deleted successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to delete ticket');
    },
  });
};
